import {
  FieldTitle,
  RadioButtonGroupMapping,
  RadioButtonType,
  RadioButtons,
  TextInput,
} from '@labrav/react-components'
import {
  ContractDurationType,
  DiscountType,
} from '../../../../admin/modules/resaleAuthorizations'
import { getKeyFromValue } from '../../../../common/utils/getKeyFromValue'
import { KeyValue } from '../../../../modules/privateOffer/privateOfferCreation/types'
import { ResaleAuthorizationWithErrors } from '../../../../modules/resaleAuthorization/types'
import { useCallback, useState, useEffect } from 'react'
import { Typography } from '@mui/material'
import { useStyles } from './ContractDuration.styles'
import { isEmpty } from 'lodash'
import { getValidValueBetweenMinMax } from '@labrav/common'

const discountMapping: RadioButtonGroupMapping[] = [
  {
    key: ContractDurationType.STANDARD,
    label: 'Standard',
    type: RadioButtonType.STANDARD,
  },
  {
    key: ContractDurationType.CUSTOM,
    label: 'Custom',
    type: RadioButtonType.STANDARD,
  },
]
export type ContractDurationProps = {
  resaleAuthorizationWithError: ResaleAuthorizationWithErrors
  handleChange: (data: KeyValue) => void
}

export const ContractDuration = ({
  resaleAuthorizationWithError,
  handleChange,
}: ContractDurationProps) => {
  const { errors, contractDurationType, discountType } =
    resaleAuthorizationWithError
  const { classes } = useStyles()

  const [
    contractDurationInMonthsForEndCustomerValue,
    setContractDurationInMonthsForEndCustomerValue,
  ] = useState<number | undefined>(
    resaleAuthorizationWithError.contractDurationInMonthsForEndCustomer
  )

  useEffect(() => {
    setContractDurationInMonthsForEndCustomerValue(
      resaleAuthorizationWithError.contractDurationInMonthsForEndCustomer
    )
  }, [resaleAuthorizationWithError.contractDurationInMonthsForEndCustomer])

  const handleUpdateContractDurationType = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange({
        key: 'contractDurationType',
        value: (event.target as HTMLInputElement).value,
      })
    },
    [contractDurationType]
  )

  const handleUpdate = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const updatedValue = getValidValueBetweenMinMax(
        event.target.value !== ''
          ? `${Math.round(Number(event.target.value))}`
          : (event.target.value as string),
        1,
        144
      )
      setContractDurationInMonthsForEndCustomerValue(updatedValue)
      handleChange({
        key: 'contractDurationInMonthsForEndCustomer',
        value: updatedValue || '',
      })
    },
    []
  )

  const showContractDurationInput =
    contractDurationType &&
    ((discountType === DiscountType.INDIVIDUAL_PRICING &&
      contractDurationType === ContractDurationType.CUSTOM) ||
      discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS)

  return (
    <div>
      <div className={classes.headingContainer}>
        <FieldTitle isRequired={true} title={''} />
        <Typography className={classes.contractDurationHeading}>
          Contract Duration
        </Typography>
      </div>
      <RadioButtons
        checkedValue={{
          key: getKeyFromValue(contractDurationType)(
            ContractDurationType
          ) as string,
          value: contractDurationType || '',
        }}
        handleChange={handleUpdateContractDurationType}
        radioButtonMappings={discountMapping}
      />
      {showContractDurationInput && (
        <TextInput
          isRequired={true}
          keyName="contractDurationInMonthsForEndCustomer"
          title="Custom Duration (In Months)"
          type="number"
          placeHolder=""
          key="contractDurationInMonthsForEndCustomer"
          isReadOnly={false}
          value={
            resaleAuthorizationWithError.contractDurationInMonthsForEndCustomer ||
            ''
          }
          updatedValue={contractDurationInMonthsForEndCustomerValue || ''}
          onChange={handleUpdate}
          isError={
            !isEmpty(errors?.contractDurationInMonthsForEndCustomer as string)
          }
          errorText={
            (errors?.contractDurationInMonthsForEndCustomer as string) || ''
          }
          minNumber={1}
          maxNumber={144}
          variant="regularV2"
        />
      )}
    </div>
  )
}
